import { Card, CardContent, CardHeader, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingCart, Star, Heart } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ProductGridProps {
  products: {
    id: string;
    name: string;
    price: number;
    discount_price?: number;
    image_url: string;
    sold: number;
    rating: number;
    stock: number;
  }[];
  className?: string;
}

export const ProductGrid = ({ products, className = "" }: ProductGridProps) => {
  return (
    <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 ${className}`}>
      {products.map((product) => (
        <Card key={product.id} className="hover:shadow-md transition-shadow h-full flex flex-col">
          {/* Product Image */}
          <div className="relative aspect-square overflow-hidden rounded-t-lg">
            <img
              src={product.image_url || "/placeholder-product.jpg"}
              alt={product.name}
              className="w-full h-full object-cover"
            />
            {product.discount_price && (
              <Badge variant="destructive" className="absolute top-2 left-2">
                {Math.round(((product.price - product.discount_price) / product.price) * 100)}%
              </Badge>
            )}
            <Button 
              variant="ghost" 
              size="icon" 
              className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 hover:bg-white"
            >
              <Heart className="w-4 h-4" />
            </Button>
          </div>

          {/* Product Info */}
          <CardHeader className="p-3 flex-1">
            <h3 className="font-medium text-sm line-clamp-2">{product.name}</h3>
            <div className="mt-2">
              {product.discount_price ? (
                <div className="flex items-baseline gap-2">
                  <span className="text-base font-bold text-red-600">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(product.discount_price)}
                  </span>
                  <span className="text-xs text-gray-500 line-through">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                    }).format(product.price)}
                  </span>
                </div>
              ) : (
                <span className="text-base font-bold">
                  {new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0,
                  }).format(product.price)}
                </span>
              )}
            </div>
            <div className="flex items-center mt-2 gap-1">
              <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
              {/* <span className="text-xs text-gray-600">{product.rating.toFixed(1)}</span> */}
              <span className="text-xs text-gray-400 mx-1">•</span>
              <span className="text-xs text-gray-600">Terjual {product.sold}</span>
            </div>
          </CardHeader>

          {/* Product Action */}
          <CardFooter className="p-3 border-t">
            <Button variant="outline" size="sm" className="w-full gap-2">
              <ShoppingCart className="w-4 h-4" />
              Beli
            </Button>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};